import gql from 'graphql-tag';

import CARE_PLAN_ACTIVITY_FRAGMENT from 'graph/fragments/carePlanActivity';

export const carePlans = gql`
  query carePlans {
    carePlans {
      id
      carePlanActivities {
        ...carePlanActivity
      }
    }
  }
  ${CARE_PLAN_ACTIVITY_FRAGMENT}
`;

export const carePlansComplete = gql`
  query carePlans {
    carePlans {
      id
      carePlanActivities(status: "completed") {
        ...carePlanActivity
      }
    }
  }
  ${CARE_PLAN_ACTIVITY_FRAGMENT}
`;

export const carePlansIncomplete = gql`
  query carePlans {
    carePlans {
      id
      carePlanActivities(status: "not_started") {
        ...carePlanActivity
      }
    }
  }
  ${CARE_PLAN_ACTIVITY_FRAGMENT}
`;

export const taskStats = gql`
  query carePlan($id: ID!) {
    carePlanStats: carePlan(id: $id) {
      id
      incomplete: carePlanActivities(status: "not_started") {
        id
        updatedAt
      }
      complete: carePlanActivities(status: "completed") {
        id
        updatedAt
      }
      total: carePlanActivities {
        id
        updatedAt
      }
    }
  }
`;

export const carePlanActivity = gql`
  query carePlanActivity($id: ID!) {
    carePlanActivity(id: $id) {
      ...carePlanActivity
    }
  }
  ${CARE_PLAN_ACTIVITY_FRAGMENT}
`;
